import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "hockey/overview",
  "description": "ŠKODA – генеральный спонсор чемпионата мира по хоккею 2021. Узнайте расписание матчей сборной России на ЧМ 2021, состав участников чемпионата, турнирное положение, а еще 5 фактов о ЧМХ, о которых вы точно не знали! Официальный сайт SKODA в России.",
  "keywords": "",
  "name": "hockey",
  "previewInfo": {
    "dateEnd": "",
    "dateStart": "",
    "href": "",
    "src": "/m/jhockey2021-kv-new.jpg",
    "subTitle": "",
    "tag": "",
    "text": "",
    "title": ""
  },
  "title": "Чемпионат мира по хоккею 2021: расписание матчей России, таблица – ŠKODA – Генеральный спонсор ЧМ по хоккею | ŠKODA Хоккей"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const VideoPlayer = makeShortcode("VideoPlayer");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const GridRow = makeShortcode("GridRow");
const GridCol = makeShortcode("GridCol");
const SlideIcon = makeShortcode("SlideIcon");
const Slider = makeShortcode("Slider");
const ListMobileSlider = makeShortcode("ListMobileSlider");
const SocialBlockHOC = makeShortcode("SocialBlockHOC");
const QueriedGallery = makeShortcode("QueriedGallery");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="top" horizontalAlign="left" src="/m/hockey2021-overview-main-kv.jpg" mobileSrc="/m/hockey2021-overview-main-kv-mobile.png" height={100} mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading"> ŠKODA hockey edition</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ХОККЕЙ — НАША ИГРА</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "18px"
        }}>
      Что связывает Россию и Чехию? Ну конечно, любовь к марке <b>ŠKODA</b>. А
      ещё? Любовь к <b>хоккею</b>! В обеих странах хоккей – больше чем командная
      игра. Нас объединяет страсть к победе, большая игра и настоящий драйв! Для{" "}
      <b>ŠKODA</b> хоккей — самый главный вид спорта.{" "}
      <b>
        Поэтому ŠKODA генеральный спонсор Чемпионата мира по хоккею уже 30 лет!
      </b>
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">У любви к хоккею нет границ</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "18px"
        }}>
      На трибунах, в дороге или дома – нас объединяет нечто большее чем спорт.
      <br />
      Вместе мы болеем за любимую команду, по-настоящему радуемся и поддерживаем
      друг друга.
      <br />И эту любовь к хоккею мы воплотили в серии <b>
        ŠKODA HOCKEY EDITION
      </b>.
    </p>
  </DefaultSectionText>
  <VideoPlayer padding="16/9" previewSrc="https://webgate.skoda-avto.ru/upload/video-brand-website/hockey2021-overview-main-kv-videoimg.jpg" videoSrc={{
        "video/mp4": "https://webgate.skoda-avto.ru/upload/video-brand-website/hockey-overview-video.mp4"
      }} mdxType="VideoPlayer" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    СПЕЦИАЛЬНАЯ СЕРИЯ HOCKEY EDITION
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "18px"
        }}>
      Когда команда <b>ŠKODA HOCKEY EDITION</b> «выходит на лед» - в победе
      можно не сомневаться!
    </p>
    <p style={{
          "fontSize": "18px"
        }}>
      Впечатляющий <b>ŠKODA KODIAQ</b> с полностью светодиодными фарами ни за
      что не упустит противника из виду. Динамичный <b>ŠKODA RAPID</b> в новой
      экипировке и с кожаным мультирулем поможет вовремя перехватить инициативу
      и удерживать ее благодаря системе климат-контроля Climatronic. И совсем
      недавно к команде HOCKEY EDITION присоединились новые игроки: долгожданный{" "}
      <b>ŠKODA KAROQ</b> и абсолютно новая <b>ŠKODA OCTAVIA</b>.
    </p>
  </DefaultSectionText>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/models/hockey-edition-overview" mdxType="Button"> ПОДРОБНЕЕ О СЕРИИ </Button>
    <Button type="secondary" href="/test-drive" mdxType="Button">
      ЗАПИСЬ НА ТЕСТ-ДРАЙВ
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> ЧЕМПИОНАТ МИРА ПО ХОККЕЮ 2021 </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "18px"
        }}>
      <b>Чемпионат мира по хоккею</b> в 2021 году прошел{" "}
      <b>с 21 мая по 6 июня</b> в столице Латвии Риге. Матчи турнира принимали
      стадион «Арена Рига» и Олимпийский спортивный центр. Это было{" "}
      <b>29-е мировое первенство</b>, партнером которого выступила <b>ŠKODA</b>.
      Статус генерального спонсора Чемпионата мира по хоккею IIHF марка получила{" "}
      <b>в 1993 году</b>. Это самое длительное сотрудничество в истории
      спортивных дисциплин, вошедшее в <b>Книгу рекордов Гиннесса</b>.
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> УЧАСТНИКИ И ТУРНИРНАЯ ТАБЛИЦА </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "18px"
        }}>
      Участие в турнире принимают 16 национальных команд, разбитые на две группы
      по восемь сборных. В четвертьфинал выходят по четыре лучшие команды из
      каждой группы
    </p>
  </DefaultSectionText>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "22px",
          "fontWeight": "bold"
        }}> ГРУППА А </p>
  </DefaultSectionText>
  <GridRow mdxType="GridRow">
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-russia.png" title="Россия" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-sweden.png" title="Швеция" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-czech.png" title="Чехия" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-switzerland.png" title="Швейцария" size="big" mdxType="SlideIcon" />
    </GridCol>
  </GridRow>
  <GridRow mdxType="GridRow">
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-slovakia.png" title="Словакия" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-denmark.png" title="Дания" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-great-britain.png" title="Великобритания" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-belarus.png" title="Беларусь" size="big" mdxType="SlideIcon" />
    </GridCol>
  </GridRow>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "22px",
          "fontWeight": "bold"
        }}> ГРУППА В </p>
  </DefaultSectionText>
  <GridRow mdxType="GridRow">
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-canada.png" title="Канада" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-finland.png" title="Финляндия" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-usa.png" title="США" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-germany.png" title="Германия" size="big" mdxType="SlideIcon" />
    </GridCol>
  </GridRow>
  <GridRow mdxType="GridRow">
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-latvia.png" title="Латвия" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-norway.png" title="Норвегия" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-italy.png" title="Италия" size="big" mdxType="SlideIcon" />
    </GridCol>
    <GridCol mobile={6} laptop={3} mdxType="GridCol">
      <SlideIcon icon="/m/hockey/img/flags/flag-kazakhstan.png" title="Казахстан" size="big" mdxType="SlideIcon" />
    </GridCol>
  </GridRow>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> ПРИЗОВЫЕ МЕСТА </DefaultSectionHeading>
  <Slider slidesToShow={3} mdxType="Slider">
    <SlideIcon key="/m/hockey/img/flags/flag-canada.png" icon="/m/hockey/img/flags/flag-canada.png" title="Чемпион" text="Канада" size="big" mdxType="SlideIcon" />
    <SlideIcon key="/m/hockey/img/flags/flag-finland.png" icon="/m/hockey/img/flags/flag-finland.png" title="Серебряный призёр" text="Финляндия" size="big" mdxType="SlideIcon" />
    <SlideIcon key="/m/hockey/img/flags/flag-usa.png" icon="/m/hockey/img/flags/flag-usa.png" title="Бронзовый призёр" text="США" size="big" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    5 ФАКТОВ О ЧМХ, О КОТОРЫХ ВЫ НЕ ЗНАЛИ
  </DefaultSectionHeading>
  <ListMobileSlider mdxType="ListMobileSlider">
    <SlideIcon icon="/m/icon-one.png" size="small" text="Несмотря на то, что хоккей традиционно считается зимним видом спорта, первый Чемпионат мира по хоккею с шайбой в 1920 году проводился в рамках Летних Олимпийских игр." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-two.png" size="small" text="Правила хоккея на первом Чемпионате отличались от сегодняшних. Например, в команде было семь, а не шесть игроков." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-three.png" size="small" text="Сложно поверить, но профессиональным спортсменам было разрешено принимать участие в матчах ЧМХ только в 1977 году. До этого на лёд выходили только хоккеисты-любители." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-four.png" size="small" text="Сборная СССР выиграла призовую медаль в каждом Чемпионате мира по хоккею, в котором участвовала." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-five.png" size="small" text="Хотя изобретение хоккея часто приписывают канадцам, впервые Чемпионат мира по хоккею прошёл в Канаде только в 2008 году." contentMaxWidth="300px" mdxType="SlideIcon" />
  </ListMobileSlider>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    <p style={{
          "fontSize": "22px"
        }}>
      <b>Хоккей – это больше, чем игра. Это жизнь.</b>
    </p>
    <p style={{
          "fontSize": "22px"
        }}>
      <b>ŠKODA – генеральный спонсор Чемпионата мира по хоккею.</b>
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    Присоединяйтесь к нашим сообществам в социальных сетях
  </DefaultSectionText>
  <SocialBlockHOC itemCustomStyle="background: #fff; border: 1px solid #D8D8D8;" centerMode mdxType="SocialBlockHOC" />
  <DefaultSectionText mdxType="DefaultSectionText"></DefaultSectionText>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/subscribe" className="btn" mdxType="Button">
      Подписаться на новости
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <QueriedGallery presetName="4" tags="kpk2019-links" noPb mdxType="QueriedGallery" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      